import { Card, Grid } from '@mui/material';
import DashboardCards from '../../components/DashboardCard/DashboardCards';
import { TITLES } from '../../utils/constants';
import { PackageHeader } from '../../components/CustomHeading';
import useStyles from '../../hooks/useStyles';
import styles from '../../layouts/pages/style';
import useScoreInsights from './useScoreInsights';
import { KpiScoreSizeBubble, VersionScoreDistribution } from '../../modules/ScoreInsights';

export default function ScoreInsights() {
  const {
    kpiScoreSize,
    versionScoreDist,
    setRefreshKpiScoreSize,
    setRefreshVersionScore,
    packageListData,
    selectedPackage,
    handlePackageChange,
  } = useScoreInsights();

  const classes = useStyles(styles)();

  return (
    <Grid container gap={2}>
      <Grid item xs={12} className={classes.cardStyles}>
        <PackageHeader noPackage heading={TITLES.SCORE_INSIGHTS} />
      </Grid>

      <Grid item xs={12}>
        <Card className={classes.graphStyle}>
          <KpiScoreSizeBubble
            loading={kpiScoreSize.loading}
            error={kpiScoreSize.error}
            data={kpiScoreSize.data}
            refresh={setRefreshKpiScoreSize}
          />
        </Card>
      </Grid>

      <Grid container item xs={12}>
        <Grid item xs={12}>
          <DashboardCards
            title="Version KPI Score Distribution"
            packageList={packageListData}
            selectedPackage={selectedPackage}
            handlePackageChange={handlePackageChange}
          >
            <VersionScoreDistribution
              loading={versionScoreDist?.loading}
              error={versionScoreDist?.error}
              data={versionScoreDist?.data}
              refresh={setRefreshVersionScore}
              message="No Data"
            />

          </DashboardCards>
        </Grid>
      </Grid>
    </Grid>
  );
}
